import { CtaButton } from "@/app/lib/Button";
import Image from "next/image";

export default function Slide2() {
  return (
    <div className="relative w-full h-[862px] lg:h-[504px] overflow-hidden pl-0 lg:pl-[56px] pr-0 lg:pr-[40px] py-[24px] lg:py-[56px]">
      <Image
        src="/slide2_bg.webp"
        alt="Python finance course banner"
        fill
        priority
        className="object-cover"
        sizes="(max-width: 1024px) 100vw, 70vw"
      />
      <div className="absolute inset-0 bg-[#09172d]/45" />
      <div className="relative flex flex-col gap-[32px] lg:gap-[40px] py-[250px] lg:py-0 px-[16px] lg:px-0">
        <div className="flex flex-col items-start gap-[16px]">
          <h2 className="text-white text-[48px] md:text-[61px] font-[600] leading-[100%] max-w-[560px]">
            <span className="text-[#FFC027]">Model </span>the World with Python
          </h2>
          <h4 className="text-[32px] lg:text-[36px] max-w-[520px] text-[#d7e5fb] font-[600] leading-[100%]">
            Develop strong foundations in computational thinking and real-world
            modelling
          </h4>
        </div>
        <div className="w-full md:w-auto">
          <CtaButton text={"Start Learning Now"} />
        </div>
      </div>
    </div>
  );
}
